<template>
  <div class="back">
    <div class="head">
      <img :src="info.img" class="icon" />
      <p class="itemTitle">{{ info.name }}</p>
      <p class="moreBtn" @click="clickMore()">更多</p>
    </div>
    <p
      v-for="index in contentList.length"
      :key="index"
      class="content"
      @click="clickItem(index)"
    >
      {{ index }} {{ contentList[index - 1].title }}
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contentList: [],
    };
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  created() {},
  mounted() {
    this.contentList = this.info.data;
    // console.log("this.contentList=", this.contentList);
  },
  methods: {
    clickMore() {
      this.$emit("clickMore", this.info);
    },
    clickItem(index) {
      let info = this.contentList[index - 1];
      console.log(info.url);
      this.$emit("clickItem", info.url);
    },
  },
};
</script>
<style lang="scss" scoped>
.back {
  border-radius: 30px;
  border-style: none;
  width: 270px;
  height: 340px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  align-items: center;
  // margin: 20px 40px 20px 0px;
  overflow: hidden;
  background-color: #ffffff;
}
.head {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  align-items: center;
}
.icon {
  width: 32px;
  height: 32px;
  background-color: unset;
}
.itemTitle {
  color: #000000;
  font-size: 18px;
  line-height: 18px;
  margin: 0px;
  text-align: left;
  margin-left: 12px;
}
.moreBtn {
  text-align: right;
  color: #000000;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
  position: absolute;
  right: 0px;
}
.content {
  width: 100%;
  margin: 5px;
  font-size: 14px;
  line-height: 35px;
  color: #000000;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: left;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .back {
    border-radius: 30px;
    border-style: none;
    width: 100%;
    height: 340px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    align-items: center;
    // margin: 20px 40px 20px 0px;
    overflow: hidden;
    background-color: #ffffff;
    margin-bottom: 30px;
  }
  .head {
    display: flex;
    flex-direction: row;
    width: 100%;
    position: relative;
    align-items: center;
  }
  .icon {
    width: 32px;
    height: 32px;
    background-color: unset;
  }
  .itemTitle {
    color: #000000;
    font-size: 18px;
    line-height: 18px;
    margin: 0px;
    text-align: left;
    margin-left: 12px;
  }
  .moreBtn {
    text-align: right;
    color: #000000;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    position: absolute;
    right: 0px;
  }
  .content {
    width: 100%;
    margin: 5px;
    font-size: 14px;
    line-height: 35px;
    color: #000000;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-align: left;
    cursor: pointer;
  }
}
</style>
